import { SubTitle } from "@stories/atoms/SubTitle/SubTitle";
import * as RouteHelper from "@utils/routes";
import { PageBreadcrumbs } from "@stories/atoms/PageBreadcrumbs/PageBreadcrumbs";
import { useProfile } from "@hooks/crud/useProfile";
import { UserTable } from "@stories/molecules/UserTable/UserTable";
import { useState } from "react";
import { ProfileLineItem } from "@interfaces/profile";
import { useProfileContext } from "@hooks/context/useProfileContext";
import UserModal from "@stories/organisms/UserModal/UserModal";
import { createDefaultUser } from "@interfaces/user";
import { PageLoader } from "@stories/atoms/Loaders/PageLoader/PageLoader";
import { ProjectLoader } from "@stories/atoms/Loaders/ProjectLoader/ProjectLoader";

export const Users = () => {
  const { userProfile, userOrganisation } = useProfileContext();
  const [selectedProfile, setSelectedProfile] = useState<
    ProfileLineItem | undefined
  >(undefined);
  const {
    profiles,
    isProfileLoading,
    deleteProfile,
    createProfile,
    updateProfile,
  } = useProfile(userOrganisation?.id);

  const [open, setOpen] = useState(false);

  if (!userProfile || !userOrganisation) {
    console.log("USers PAGE LOADER");
    return <ProjectLoader />;
  }
  const handleClose = () => {
    setOpen(false);
    setSelectedProfile(undefined);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleCreateUser = async (profile: ProfileLineItem) => {
    const newUser = createDefaultUser(profile.email);
    await createProfile({
      ...profile,
      id: newUser.id,
    });
  };

  const handleEditUser = (profile: ProfileLineItem) => {
    setSelectedProfile(profile);
    handleOpen();
  };

  const handleDeleteUser = (profile: ProfileLineItem) => {
    deleteProfile(profile);
  };

  const breadcrumbs = [
    {
      path: RouteHelper.users,
      name: "Users",
    },
  ];
  return (
    <>
      <PageBreadcrumbs
        title={"Users"}
        organisationLogo={userOrganisation.organisationLogo}
        links={breadcrumbs}
      />
      <SubTitle title={"Users"} />
      <UserTable
        loading={isProfileLoading}
        profile={userProfile}
        profiles={profiles}
        handleOpen={handleOpen}
        handleEditUser={handleEditUser}
        handleDeleteUser={handleDeleteUser}
      />
      {userProfile ? (
        <UserModal
          open={open}
          loading={isProfileLoading}
          organisation={userOrganisation}
          profiles={profiles}
          handleClose={handleClose}
          createUser={handleCreateUser}
          updateUser={updateProfile}
          existingUser={selectedProfile}
        />
      ) : null}
    </>
  );
};
